module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/media/lobby-music.72ab3392.mp3";